export const CouldNotConnectToAccountTitleText = "Zjc";
export const MailMessageFileProviderDisplayName = "_jc";
export default {CouldNotConnectToAccountTitleText,MailMessageFileProviderDisplayName};